( () => {
    "use strict";
    var e = document.querySelector(".modal-chart")
      , t = document.querySelector(".size-chart-btn")
      , i = document.getElementsByClassName("close")[0];
    t && (t.onclick = function() {
        e.style.display = "block",
        e.style.zIndex = "999",
        modalTopHeight = 0,
        e.style.top = Math.round(modalTopHeight - 85) + "px"
    }
    ),
    i && (i.onclick = function() {
        e.style.display = "none"
    }
    ),
    window.onclick = function(t) {
        t.target == e && (e.style.display = "none")
    }
    ,
    document.querySelectorAll(".site-nav__link").forEach((function(e) {
        e.addEventListener("mouseover", (function(t) {
            var i = e.querySelector("span").dataset.menu;
            document.querySelectorAll(".mega-container").forEach((function(e) {
                e.classList.add("hidden")
            }
            )),
            document.querySelector(".mega-container.mega-" + i) && document.querySelector(".mega-container.mega-" + i).classList.remove("hidden"),
            document.querySelector("#myHeader").classList.add("megamenu-open")
        }
        ))
    }
    )),
    document.querySelectorAll(".mega-container").forEach((function(e) {
        e.addEventListener("mouseleave", (function(e) {
            e.target.classList.add("hidden")
        }
        ))
    }
    )),
    document.querySelector("#myHeader").addEventListener("mouseleave", (function(e) {
        document.querySelector("#myHeader").classList.remove("megamenu-open")
    }
    )),
    jQuery(document).ready((function() {
        var e = document.querySelector(".collection-grid-item__title");
        e && (e.style.fontFamily = "Ogg");
        var t = document.querySelector(".blog-card");
        t && (t.style.borderLeft = "none")
    }
    )),
    window.Milanimal = {
        Abstract: {
            getQueryVariable: function(e) {
                for (var t = window.location.search.substring(1).split("&"), i = 0; i < t.length; i++) {
                    var r = t[i].split("=");
                    if (r[0] == e)
                        return decodeURIComponent(r[1])
                }
                return !1
            },
            iOS: function() {
                var e = ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"];
                if (navigator.platform)
                    for (; e.length; )
                        if (navigator.platform === e.pop())
                            return !0;
                return !1
            },
            mobileCheck: function() {
                var e, t = !1;
                return e = navigator.userAgent || navigator.vendor || window.opera,
                (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|p    alm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|a    i(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|    da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi    (pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no    |xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|    n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|    60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\    -|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|    70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4))) && (t = !0),
                t
            },
            findAncestor: function(e, t) {
                for (; (e = e.parentElement) && !e.classList.contains(t); )
                    ;
                return e
            },
            combination: function(e, t) {
                var i = []
                  , r = [];
                return function e(n, a, o) {
                    if (0 !== a)
                        for (var c = o; c <= n.length - a; c++)
                            i[t - a] = n[c],
                            e(n, a - 1, c + 1);
                    else
                        r.push(i.join(" "))
                }(e, t, 0),
                r
            }
        },
        Cart: {
            $siteHeader: null,
            $cartSidebar: null,
            $cartSidebarJs: null,
            $cartProductRemove: null,
            addToCartClicked: !1,
            cart_open: !1,
            mount: function() {
                if (this.$cartSidebar = jQuery("#site-nav--mobile"),
                this.$cartSidebarJs = document.getElementById("site-nav--mobile"),
                this.$cartProductRemove = document.getElementById(".remove-product-from-cart"),
                this.$siteHeader = $("header"),
                jQuery(".site-header__cart").length) {
                    jQuery(".site-header__cart").addClass("block-fade"),
                    parseInt(jQuery(".site-header__cart span").text()) > 0 && jQuery(".site-header__cart").addClass("cart-up-zero"),
                    jQuery(".site-header__cart").on("click", function(e) {
                        jQuery("#cartMobile").is(":visible") ? this.updateCartCount() : (e.preventDefault(),
                        this.$cartSidebar.hasClass("active") || (e.stopPropagation(),
                        this.openSidebarCart()))
                    }
                    .bind(this)),
                    jQuery(".site-close-handle, header, .page-container, .closebtn").on("click", function() {
                        this.$cartSidebar.hasClass("active") && this.closeSidebarCart()
                    }
                    .bind(this)),
                    this.onSearchClickAction(),
                    $(window).resize(function(e) {
                        window.innerWidth < 750 && this.closeSidebarCart()
                    }
                    .bind(this)),
                    jQuery(".product-form__cart-submit").on("click", function() {
                        var e;
                        this.addToCartClicked = !0,
                        null === (e = document.querySelector(".add-to-cart-price")) || void 0 === e || e.classList.add("hide"),
                        setTimeout((function() {
                            var e;
                            null === (e = document.querySelector(".add-to-cart-price")) || void 0 === e || e.classList.remove("hide")
                        }
                        ), 2e3)
                    }
                    .bind(this));
                    var e = document.querySelector(".product-form__cart-submit span")
                      , t = new MutationObserver((function(e) {
                        e.forEach((function(e) {
                            var t = e.target;
                            window.Milanimal.Cart.addToCartClicked && 0 == t.classList.length && (window.Milanimal.Cart.updateCart(),
                            window.Milanimal.Cart.addToCartClicked = !1)
                        }
                        ))
                    }
                    ));
                    e && t.observe(e, {
                        attributes: !0,
                        childList: !0,
                        characterData: !0
                    })
                }
            },
            openSidebarCart: function() {
                var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                this.$cartSidebar.hasClass("active") || 0 == document.querySelector(".site-header__cart span").innerText || (this.cart_open = !0,
                this.$cartSidebar.addClass("active"),
                this.$cartSidebar.removeClass("show-filters").removeClass("show-search").addClass("show-cart"),
                jQuery(".js-drawer-open.js-drawer-open-top").length && jQuery(".js-drawer-open.js-drawer-open-top").each((function() {
                    jQuery(this).removeClass("js-drawer-open").removeClass("js-drawer-open-top")
                }
                )),
                e && (this.bindActionsCart(),
                this.updateCartCount()))
            },
            closeSidebarCart: function() {
                this.$cartSidebar.hasClass("active") && (this.$cartSidebar.removeClass("active"),
                this.cart_open = !1)
            },
            updateCart: function(e) {
                jQuery.getJSON("/cart.js", function(e) {
                    this.$cartSidebarJs.querySelector(".subtitle").dataset.count != e.item_count && (this.$cartSidebarJs.querySelector(".cart-items").innerHTML = "",
                    this.$cartSidebarJs.querySelector(".cart-items").innerHTML = '<span class="cart-loader"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"></path></svg></span>',
                    e.items.length > 0 ? (e.items.forEach(function(e, t) {
                        var i = t + 1;
                        jQuery.getJSON("/products/" + e.handle + "/images.json", function(t) {
                            var r = document.createElement("DIV");
                            r.classList.add("cart-item"),
                            r.classList.add("cart-item-line-" + i);
                            var n = document.createElement("DIV");
                            n.classList.add("image");
                            var a = document.createElement("A");
                            a.classList.add("thumbnail"),
                            a.setAttribute("href", e.url);
                            var o = document.createElement("IMG")
                              , c = t.product.images[0].src;
                            e.variant_options.length > 1 && t.product.images.some((function(t) {
                                return -1 != e.variant_options.indexOf(t.alt) && (c = t.src,
                                !0)
                            }
                            )),
                            o.setAttribute("src", this._buildImageUrl(c, [{
                                key: "img_url",
                                value: "200x240"
                            }, {
                                key: "crop",
                                value: "center"
                            }])),
                            o.setAttribute("alt", e.title),
                            a.appendChild(o),
                            n.appendChild(a),
                            r.appendChild(n);
                            var l = document.createElement("DIV");
                            l.classList.add("content");
                            var s = document.createElement("DIV");
                            s.classList.add("product-info");
                            var d = document.createElement("DIV");
                            d.classList.add("product-title");
                            var u = document.createElement("A");
                            u.classList.add("title"),
                            u.setAttribute("href", e.url),
                            u.innerHTML = e.product_title,
                            "" != e.variant_title && e.options_with_values.forEach((function(e) {
                                if ("Material" != e.name) {
                                    u.innerHTML += "<br> " + e.name + ": ";
                                    var t = document.createElement("SPAN");
                                    t.innerHTML = e.value,
                                    u.appendChild(t)
                                }
                            }
                            )),
                            d.appendChild(u),
                            s.appendChild(d);
                            var h = document.createElement("DIV");
                            h.classList.add("price");
                            var m = document.createElement("DIV");
                            m.classList.add("conditional-qty"),
                            m.classList.add("qty-" + e.quantity);
                            var p = this._getFormatPrice(e.final_price, !0);
                            if (m.innerHTML = p,
                            e.original_price > e.price) {
                                var f = document.createElement("DEL")
                                  , v = this._getFormatPrice(e.original_price, !0);
                                f.innerHTML = v,
                                m.appendChild(f)
                            }
                            if (h.appendChild(m),
                            e.quantity > 1) {
                                var y = document.createElement("DIV")
                                  , g = this._getFormatPrice(e.final_line_price, !0);
                                y.innerHTML = g;
                                var b = document.createElement("SPAN");
                                b.innerHTML = "(" + e.quantity + " x " + p + ")",
                                y.appendChild(b),
                                h.appendChild(y)
                            }
                            s.appendChild(h);
                            var S = document.createElement("DIV");
                            S.classList.add("product-quantity");
                            var w = document.createElement("DIV");
                            w.classList.add("product-quantity-input");
                            var q = document.createElement("SPAN");
                            q.innerHTML = "Qty. ";
                            var L = document.createElement("INPUT");
                            L.classList.add("update-product-qty"),
                            L.setAttribute("data-line", i),
                            L.setAttribute("value", e.quantity),
                            w.appendChild(q),
                            w.appendChild(L),
                            S.appendChild(w),
                            s.appendChild(S);
                            var C = document.createElement("DIV");
                            C.classList.add("product-remove");
                            var A = document.createElement("A");
                            A.classList.add("remove"),
                            A.classList.add("remove-product-from-cart"),
                            A.setAttribute("href", "/cart/change?line=" + i + "&quantity=0"),
                            A.setAttribute("title", "remove item"),
                            A.setAttribute("data-line", i),
                            A.setAttribute("aria-label", "remove item");
                            var E = document.createElement("SPAN");
                            E.setAttribute("aria-hidden", "true"),
                            E.innerHTML = "Remove",
                            A.appendChild(E),
                            C.appendChild(A),
                            s.appendChild(C),
                            l.appendChild(s),
                            r.appendChild(l),
                            this.$cartSidebarJs.querySelector(".cart-items").querySelector(".cart-loader") && (this.$cartSidebarJs.querySelector(".cart-items").innerHTML = ""),
                            this.$cartSidebarJs.querySelector(".cart-items").appendChild(r),
                            itemJustAdded = jQuery(".cart-items .cart-item-line-" + i),
                            this.bindActionsCart(itemJustAdded)
                        }
                        .bind(this))
                    }
                    .bind(this)),
                    this.$cartSidebarJs.querySelector(".cart-totals").style.display = "flex") : (this.$cartSidebarJs.querySelector(".cart-totals").style.display = "none",
                    this.closeSidebarCart()),
                    document.querySelector(".cart-totals input").value = "Check out   € " + this._getFormatPrice(e.total_price, !1),
                    this.updateCartCount(e.item_count),
                    jQuery("#cartMobile").is(":visible") || this.openSidebarCart(!1)),
                    parseInt(jQuery(".site-header__cart span").text()) > 0 ? jQuery(".site-header__cart").addClass("cart-up-zero") : jQuery(".site-header__cart").removeClass("cart-up-zero")
                }
                .bind(this))
            },
            bindActionsCart: function(e) {
                var t = jQuery("body");
                e && (t = e),
                t.find(".product-remove").length && t.find(".product-remove").not(".bound").on("click", (function(e) {
                    e.preventDefault(),
                    jQuery(this).unbind();
                    var t = jQuery(this).find("a").data("line");
                    jQuery(this).addClass("bound"),
                    jQuery.post("/cart/change.js", {
                        quantity: 0,
                        line: t
                    }, (function(e) {
                        window.Milanimal.Cart.updateCart()
                    }
                    ), "json")
                }
                )),
                t.find(".update-product-qty").length && t.find(".update-product-qty").not(".bound").on("change", (function(e) {
                    jQuery(this).unbind();
                    var t = jQuery(this).data("line")
                      , i = jQuery(this).val();
                    jQuery(this).addClass("bound"),
                    jQuery.ajax({
                        url: "/cart/change.js",
                        type: "POST",
                        data: {
                            quantity: i,
                            line: t
                        },
                        dataType: "json"
                    }).done((function(e) {
                        window.Milanimal.Cart.updateCart()
                    }
                    ))
                }
                ))
            },
            updateCartCount: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0
                  , t = 0;
                t = null != e ? e : this.$cartSidebarJs.querySelector(".subtitle").dataset.count,
                this.$cartSidebarJs.querySelector(".subtitle").innerHTML = 1 == t ? this.$cartSidebarJs.querySelector(".subtitle").dataset.one : this.$cartSidebarJs.querySelector(".subtitle").dataset.more.replace("{{ count }}", t),
                document.querySelectorAll(".site-header__cart span").forEach((function(e) {
                    e.innerHTML = t
                }
                )),
                this.$cartSidebarJs.querySelector(".subtitle").dataset.count = t
            },
            _buildImageUrl: function(e, t) {
                var i = e.substr(0, e.lastIndexOf("."));
                return t.forEach((function(e) {
                    i = "img_url" === e.key ? i + "_" + e.value : i + "_" + e.key + "_" + e.value
                }
                )),
                i + e.substr(e.lastIndexOf("."), e.length)
            },
            _getFormatPrice: function(e, t) {
                var i = (e = e.toString()).substring(0, e.length - 2)
                  , r = e.substring(e.length - 2, e.length);
                return t ? "&euro;" + i + "," + r : i + "," + r
            },
            onSearchClickAction: function() {
                jQuery(".site-header__search-toggle").on("click", function() {
                    this.cart_open && this.closeSidebarCart()
                }
                .bind(this))
            }
        },
        Filters: {
            baseUrl: "",
            mount: function() {
                String.prototype.replaceAll = function(e, t) {
                    return this.split(e).join(t)
                }
                ,
                this.baseUrl = location.origin + "/collections/" + Shopify.collectionHandle + "/",
                "vendors" == location.pathname.split("/")[2] && (this.baseUrl = location.origin + "/collections/all/" + decodeURI(location.search.replace("?q=", "")).replaceAll(" ", "_")),
                this.type(),
                this.vendor(),
                this.size(),
                this.reset()
            },
            type: function() {
                jQuery(".type-filter").change(function(e) {
                    var t = e.target.value
                      , i = "";
                    t && (i = "+" + t),
                    "" == Shopify.collectionVendorFilter ? location.href = this.baseUrl + i : location.href = this.baseUrl + Shopify.collectionVendorFilter + i
                }
                .bind(this))
            },
            vendor: function() {
                jQuery(".vendor-filter").change(function(e) {
                    var t = e.target.value
                      , i = "";
                    t && (i = "+" + t),
                    "" == Shopify.collectionTypeFilter ? location.href = this.baseUrl + i : location.href = this.baseUrl + Shopify.collectionTypeFilter + i
                }
                .bind(this))
            },
            size: function() {
                jQuery(".size-filter").change(function(e) {
                    var t = e.target.value
                      , i = "";
                    t && (i = t);
                    var r = this.baseUrl;
                    "" != Shopify.collectionVendorFilter && (r += Shopify.collectionVendorFilter),
                    "" != Shopify.collectionTypeFilter && (r = r + "+" + Shopify.collectionTypeFilter),
                    r = r + "+" + i,
                    location.href = r
                }
                .bind(this))
            },
            reset: function() {
                jQuery(".reset-filter-button").click(function(e) {
                    location.href = this.baseUrl
                }
                .bind(this))
            }
        },
        Product: {
            colorSelectInput: document.getElementById("SingleOptionSelector-2"),
            sizeSelectInput: document.getElementById("SingleOptionSelector-1"),
            variantSelectInput: document.getElementById("ProductSelect-product-template"),
            currentSelectedColor: "",
            currentSelectedSize: "",
            colors: [],
            sizes: [],
            mount: function() {
                -1 !== document.location.href.indexOf("/products/") && (this.colorSelectInput && Array.prototype.forEach.call(this.colorSelectInput.options, function(e) {
                    this.colors.push(window.Milanimal.CollectionAjax.revertFilterString(e.value))
                }
                .bind(this)),
                this.sizeSelectInput && Array.prototype.forEach.call(this.sizeSelectInput.options, function(e) {
                    this.sizes.push(e.value)
                }
                .bind(this)),
                (this.colorSelectInput || this.sizeSelectInput) && this.run(),
                this.selectFirstAvailableSize(),
                this.tabsActions())
            },
            run: function() {
                if (this.listenBoxClick(),
                document.querySelector(".color-box-selector")) {
                    document.querySelector(".color-box-selector[data-value='" + this.getSelectedColor() + "']").classList.add("selected"),
                    document.querySelector(".selector-color-text span[data-value='" + this.getSelectedColor() + "']").classList.remove("hidden");
                    var e = document.querySelector(".selector-color-text span[data-value='" + this.getSelectedColor() + "']").dataset.original;
                    this.triggerInputChange(this.colorSelectInput, e),
                    this.changeImages()
                }
                document.querySelector(".size-box-selector[data-value='" + this.getSelectedSize() + "']").classList.add("selected"),
                this.triggerInputChange(this.sizeSelectInput, this.getSelectedSize()),
                this.crossUnavailableSizes()
            },
            selectFirstAvailableSize: function() {
                if (document.querySelector(".size-box-selector.selected.unavailable")) {
                    var e = "";
                    window.productAvailability && window.productAvailability.some(function(t) {
                        if (this.getSelectedColor() && t.color == this.getSelectedColor() && "true" == t.available || !this.getSelectedColor() && "true" == t.available)
                            return e = t.size,
                            !0
                    }
                    .bind(this)),
                    document.querySelector(".size-box-selector[data-value='" + e + "']").dispatchEvent(new Event("click"));
                    var t = setInterval(function() {
                        document.querySelector("button.product-form__cart-submit").getAttribute("aria-disabled") ? this.triggerInputChange(this.sizeSelectInput, e) : clearInterval(t)
                    }
                    .bind(this), 100)
                }
            },
            getSelectedColor: function() {
                if (!document.querySelector(".color-box-selector"))
                    return !1;
                if ("" == this.currentSelectedColor)
                    if (window.Milanimal.Abstract.getQueryVariable("variant")) {
                        var e = window.Milanimal.Abstract.getQueryVariable("variant");
                        window.ShopifyAnalytics.meta.product.variants.forEach(function(t) {
                            t.id == e && this.colors.some(function(e) {
                                return e = e.toLowerCase(),
                                -1 !== t.name.toLowerCase().indexOf(e) && (this.currentSelectedColor = window.Milanimal.CollectionAjax.applyFilterString(e),
                                !0)
                            }
                            .bind(this))
                        }
                        .bind(this))
                    } else
                        window.Milanimal.Abstract.getQueryVariable("color") ? this.currentSelectedColor = window.Milanimal.Abstract.getQueryVariable("color") : this.currentSelectedColor = this.colorSelectInput.value;
                return window.Milanimal.CollectionAjax.applyFilterString(this.currentSelectedColor)
            },
            getSelectedSize: function() {
                if ("" == this.currentSelectedSize)
                    if (window.Milanimal.Abstract.getQueryVariable("variant")) {
                        var e = window.Milanimal.Abstract.getQueryVariable("variant");
                        window.ShopifyAnalytics.meta.product.variants.forEach(function(t) {
                            t.id == e && this.sizes.some(function(e) {
                                return -1 !== t.name.indexOf(e) && (this.currentSelectedSize = e,
                                !0)
                            }
                            .bind(this))
                        }
                        .bind(this))
                    } else
                        window.Milanimal.Abstract.getQueryVariable("color") ? this.currentSelectedSize = window.Milanimal.Abstract.getQueryVariable("color") : this.currentSelectedSize = this.sizeSelectInput.value;
                return this.currentSelectedSize
            },
            changeImages: function() {
                document.querySelectorAll(".product-single__photo-wrapper:first-child img.product-single__photo").forEach(function(e) {
                    e.dataset.color == this.getSelectedColor() ? e.classList.remove("hidden") : e.classList.add("hidden")
                }
                .bind(this));
                var e = document.querySelectorAll(".lines-images-mobile span");
                if (e.length > 0) {
                    var t = document.querySelectorAll(".product-single__photo-wrapper:first-child img.product-single__photo[data-color='" + this.getSelectedColor() + "']").length;
                    e.forEach((function(e, i) {
                        i > t && !e.classList.contains("hidden") && e.classList.add("hidden"),
                        i <= t && e.classList.contains("hidden") && e.classList.remove("hidden")
                    }
                    )),
                    e.length
                }
            },
            triggerInputChange: function(e, t) {
                e.value = t;
                var i = new Event("change");
                e.dispatchEvent(i)
            },
            listenBoxClick: function(e) {
                document.querySelectorAll(".color-box-selector").forEach(function(e) {
                    e.addEventListener("click", function(e) {
                        document.querySelector(".color-box-selector.selected") && document.querySelector(".color-box-selector.selected").classList.remove("selected");
                        var t = e.target;
                        "IMG" == e.target.nodeName && (t = e.target.parentNode),
                        null == e.target.dataset.value && (t = t.parentNode),
                        t.classList.add("selected"),
                        this.currentSelectedColor = t.dataset.value,
                        this.triggerInputChange(this.colorSelectInput, t.dataset.original),
                        this.changeImages(),
                        this.crossUnavailableSizes(),
                        document.querySelectorAll(".selector-color-text span").forEach(function(e) {
                            e.classList.contains("hidden") || e.classList.add("hidden"),
                            e.dataset.value == this.currentSelectedColor && e.classList.remove("hidden")
                        }
                        .bind(this))
                    }
                    .bind(this))
                }
                .bind(this)),
                document.querySelectorAll(".size-box-selector").forEach(function(e) {
                    e.addEventListener("click", function(e) {
                        document.querySelector(".size-box-selector.selected") && document.querySelector(".size-box-selector.selected").classList.remove("selected");
                        var t = e.target;
                        null == e.target.dataset.value && (t = t.parentNode),
                        t.classList.add("selected"),
                        this.currentSelectedSize = t.dataset.value,
                        this.triggerInputChange(this.sizeSelectInput, t.dataset.value)
                    }
                    .bind(this))
                }
                .bind(this))
            },
            tabsActions: function() {
                document.querySelectorAll(".tabs input").forEach(function(e) {
                    e.addEventListener("click", function(e) {
                        document.querySelectorAll(".tabs-description .tab-content").forEach(function(e) {
                            e.classList.add("hidden")
                        }
                        .bind(this)),
                        e.target.classList.contains("active-tab") && window.Milanimal.Abstract.mobileCheck() ? (document.getElementById(e.target.dataset.desc).classList.add("hidden"),
                        e.target.checked = !1,
                        e.target.classList.remove("active-tab")) : (document.querySelector(".tabs .active-tab") && document.querySelector(".tabs .active-tab").classList.remove("active-tab"),
                        e.target.checked = !0,
                        document.getElementById(e.target.dataset.desc).classList.remove("hidden"),
                        e.target.classList.add("active-tab"))
                    }
                    .bind(this))
                }
                .bind(this))
            },
            crossUnavailableSizes: function() {
                this.variantSelectInput && (Array.prototype.slice.call(this.variantSelectInput.querySelectorAll("option")),
                Array.prototype.slice.call(document.querySelectorAll(".size-box-selector.unavailable")).forEach(function(e) {
                    e.classList.remove("unavailable")
                }
                .bind(this)),
                window.productAvailability && window.productAvailability.forEach(function(e) {
                    var t = !1;
                    (this.getSelectedColor() && e.color == this.getSelectedColor() && "false" == e.available || !this.getSelectedColor() && "false" == e.available) && (t = !0),
                    t && document.querySelector(".size-box-selector[data-value='" + e.size + "']").classList.add("unavailable")
                }
                .bind(this)))
            }
        },
        CollectionAjax: {
            colorInput: "input.color-checkbox",
            sizeInput: "input.size-checkbox",
            typeInput: "input.type-checkbox",
            vendorInput: "input.vendor-checkbox",
            materialInput: "input.material-checkbox",
            cancelInput: ".cancel-filter-button-wrapper",
            activeFiltersToolbar: ".filters-toolbar__active .filters-toolbar__single-filters",
            toolbarButton: "accordion-filters",
            currentSelectedColor: [],
            currentSelectedSize: [],
            currentSelectedType: [],
            currentSelectedVendor: [],
            currentSelectedMaterial: [],
            currentSelectedSort: [],
            selectedFilters: [],
            colorParameter: "color",
            typeParameter: "type",
            sizeParameter: "size",
            vendorParameter: "vendor",
            materialParameter: "material",
            sortParameter: "sort_by",
            filterParameter: "f",
            shopifyOptionSize: "Size",
            shopifyOptionColor: "Color",
            shopifyOptionMaterial: "Material",
            visibleProducts: [],
            visibleProductsId: [],
            filterActive: !1,
            mount: function() {
                document.getElementsByClassName(this.toolbarButton).length && (this.toolbar(),
                this.checkUrlFilters(),
                this.listenFilters(),
                this.run(),
                window.addEventListener("scroll", (function(e) {
                    var t = document.querySelector(".filters-toolbar-wrapper");
                    t && (window.scrollY > 10 ? t.classList.add("scroll-active") : t.classList.remove("scroll-active"))
                }
                ))),
                this.deactivateAllUnavailableSizes(),
                this.changeGridImgColour()
            },
            checkUrlFilters: function() {
                window.Milanimal.Abstract.getQueryVariable(this.filterParameter) && (window.Milanimal.Abstract.getQueryVariable(this.sizeParameter) || window.Milanimal.Abstract.getQueryVariable(this.colorParameter) || window.Milanimal.Abstract.getQueryVariable(this.typeParameter) || window.Milanimal.Abstract.getQueryVariable(this.materialParameter) || window.Milanimal.Abstract.getQueryVariable(this.vendorParameter) ? (this.filterActive = !0,
                this.getFilterParameters(),
                this.selectFilterBoxes(),
                this.listenCancelButton()) : this.filterActive = !1)
            },
            checkFilters: function() {
                this.currentSelectedType.length > 0 || this.currentSelectedColor.length > 0 || this.currentSelectedSize.length > 0 || this.currentSelectedVendor.length > 0 || this.currentSelectedMaterial.length > 0 ? (this.filterActive = !0,
                this.selectedFilters = [],
                this.currentSelectedType.length > 0 && this.selectedFilters.push("type"),
                this.currentSelectedColor.length > 0 && this.selectedFilters.push("color"),
                this.currentSelectedSize.length > 0 && this.selectedFilters.push("size"),
                this.currentSelectedVendor.length > 0 && this.selectedFilters.push("vendor"),
                this.currentSelectedMaterial.length > 0 && this.selectedFilters.push("material")) : this.filterActive = !1
            },
            run: function() {
                this.checkFilters(),
                this.updateUrl(),
                this.updateFilterToolbar(),
                this.filterProducts(),
                this.listenResetButton()
            },
            getFilterParameters: function() {
                var e = this;
                this.currentSelectedSize = window.Milanimal.Abstract.getQueryVariable(this.sizeParameter) ? window.Milanimal.Abstract.getQueryVariable(this.sizeParameter).split(",") : [],
                this.currentSelectedColor = window.Milanimal.Abstract.getQueryVariable(this.colorParameter) ? window.Milanimal.Abstract.getQueryVariable(this.colorParameter).split(",") : [],
                this.currentSelectedType = window.Milanimal.Abstract.getQueryVariable(this.typeParameter) ? window.Milanimal.Abstract.getQueryVariable(this.typeParameter).split(",").map((function(t) {
                    return e.applyFilterString(t)
                }
                )) : [],
                this.currentSelectedVendor = window.Milanimal.Abstract.getQueryVariable(this.vendorParameter) ? window.Milanimal.Abstract.getQueryVariable(this.vendorParameter).split(",") : [],
                this.currentSelectedMaterial = window.Milanimal.Abstract.getQueryVariable(this.materialParameter) ? window.Milanimal.Abstract.getQueryVariable(this.materialParameter).split(",") : [],
                this.currentSelectedSort = window.Milanimal.Abstract.getQueryVariable(this.sortParameter) ? window.Milanimal.Abstract.getQueryVariable(this.sortParameter).split(",") : []
            },
            filterProducts: function() {
                this.visibleProductsId = [],
                this.visibleProducts = [],
                this.filterActive ? jQuery.getJSON("/products.json?limit=100", function(e) {
                    e.products.forEach(function(e) {
                        var t = {
                            type: this.applyFilterString(e.product_type),
                            size: this.getVariantsOptionsWithAvailability(e, this.shopifyOptionSize),
                            color: this.getVariantsOptions(e, this.shopifyOptionColor),
                            vendor: this.applyFilterString(e.vendor),
                            material: this.getVariantsOptions(e, this.shopifyOptionMaterial)
                        };
                        this.selectedFilters.length > 0 && (this.selectedFilters.length > 1 ? this.getCombinationFilters().forEach(function(i) {
                            splittedFilters = i.split(" "),
                            productMatching = !0,
                            splittedFilters.forEach((function(e, i) {
                                if (-1 !== e.indexOf("type:")) {
                                    var r = splittedFilters[i].replace("type:", "");
                                    t.type != r && (productMatching = !1)
                                }
                                if (-1 !== e.indexOf("size:")) {
                                    var n = splittedFilters[i].replace("size:", "");
                                    -1 === t.size.indexOf(n) && (productMatching = !1)
                                }
                                if (-1 !== e.indexOf("vendor:")) {
                                    var a = splittedFilters[i].replace("vendor:", "");
                                    t.vendor != a && (productMatching = !1)
                                }
                                if (-1 !== e.indexOf("color:")) {
                                    var o = splittedFilters[i].replace("color:", "");
                                    -1 === t.color.indexOf(o) && (productMatching = !1)
                                }
                                if (-1 !== e.indexOf("material:")) {
                                    var c = splittedFilters[i].replace("material:", "");
                                    -1 === t.material.indexOf(c) && (productMatching = !1)
                                }
                            }
                            )),
                            productMatching && -1 === this.visibleProductsId.indexOf(e.id) && (this.visibleProductsId.push(e.id),
                            this.visibleProducts.push(e))
                        }
                        .bind(this)) : (this.currentSelectedType.length > 0 && -1 !== this.currentSelectedType.indexOf(t.type) && -1 === this.visibleProductsId.indexOf(e.id) && (this.visibleProductsId.push(e.id),
                        this.visibleProducts.push(e)),
                        this.currentSelectedColor.length > 0 && this.currentSelectedColor.filter((function(e) {
                            return t.color.includes(e)
                        }
                        )).length > 0 && -1 === this.visibleProductsId.indexOf(e.id) && (this.visibleProductsId.push(e.id),
                        this.visibleProducts.push(e)),
                        this.currentSelectedSize.length > 0 && this.currentSelectedSize.filter((function(e) {
                            return t.size.includes(e)
                        }
                        )).length > 0 && -1 === this.visibleProductsId.indexOf(e.id) && (this.visibleProductsId.push(e.id),
                        this.visibleProducts.push(e)),
                        this.currentSelectedVendor.length > 0 && this.currentSelectedVendor.filter((function(e) {
                            return t.vendor.includes(e)
                        }
                        )).length > 0 && -1 === this.visibleProductsId.indexOf(e.id) && (this.visibleProductsId.push(e.id),
                        this.visibleProducts.push(e)),
                        this.currentSelectedMaterial.length > 0 && this.currentSelectedMaterial.filter((function(e) {
                            return t.material.includes(e)
                        }
                        )).length > 0 && -1 === this.visibleProductsId.indexOf(e.id) && (this.visibleProductsId.push(e.id),
                        this.visibleProducts.push(e))))
                    }
                    .bind(this))
                }
                .bind(this)).done(function() {
                    this.applyFilters()
                }
                .bind(this)) : this.applyFilters()
            },
            getCombinationFilters: function() {
                var e = [];
                return this.currentSelectedType.length > 0 && (typesToCombine = [],
                this.currentSelectedType.forEach((function(e) {
                    typesToCombine.push("type:" + e)
                }
                )),
                e = e.concat(typesToCombine)),
                this.currentSelectedColor.length > 0 && (colorsToCombine = [],
                this.currentSelectedColor.forEach((function(e) {
                    colorsToCombine.push("color:" + type)
                }
                )),
                e = e.concat(colorsToCombine)),
                this.currentSelectedSize.length > 0 && (sizesToCombine = [],
                this.currentSelectedSize.forEach((function(e) {
                    sizesToCombine.push("size:" + e)
                }
                )),
                e = e.concat(sizesToCombine)),
                this.currentSelectedMaterial.length > 0 && (materialsToCombine = [],
                this.currentSelectedMaterial.forEach((function(e) {
                    materialsToCombine.push("material:" + e)
                }
                )),
                e = e.concat(materialsToCombine)),
                this.currentSelectedVendor.length > 0 && (vendorsToCombine = [],
                this.currentSelectedVendor.forEach((function(e) {
                    vendorsToCombine.push("vendor:" + e)
                }
                )),
                e = e.concat(vendorsToCombine)),
                combinationFilters = window.Milanimal.Abstract.combination(e, this.selectedFilters.length),
                this.currentSelectedType.length > 1 && window.Milanimal.Abstract.combination(typesToCombine, 2).forEach(function(e) {
                    combinationFilters = combinationFilters.filter((function(t, i, r) {
                        return -1 == t.indexOf(e)
                    }
                    ))
                }
                .bind(this)),
                this.currentSelectedColor.length > 1 && window.Milanimal.Abstract.combination(colorsToCombine, 2).forEach(function(e) {
                    combinationFilters = combinationFilters.filter((function(t, i, r) {
                        return -1 == t.indexOf(e)
                    }
                    ))
                }
                .bind(this)),
                this.currentSelectedSize.length > 1 && window.Milanimal.Abstract.combination(sizesToCombine, 2).forEach(function(e) {
                    combinationFilters = combinationFilters.filter((function(t, i, r) {
                        return -1 == t.indexOf(e)
                    }
                    ))
                }
                .bind(this)),
                this.currentSelectedMaterial.length > 1 && window.Milanimal.Abstract.combination(materialsToCombine, 2).forEach(function(e) {
                    combinationFilters = combinationFilters.filter((function(t, i, r) {
                        return -1 == t.indexOf(e)
                    }
                    ))
                }
                .bind(this)),
                this.currentSelectedVendor.length > 1 && window.Milanimal.Abstract.combination(vendorsToCombine, 2).forEach(function(e) {
                    combinationFilters = combinationFilters.filter((function(t, i, r) {
                        return -1 == t.indexOf(e)
                    }
                    ))
                }
                .bind(this)),
                combinationFilters
            },
            getVariantsOptions: function(e, t) {
                var i = [];
                return e.options.forEach(function(e) {
                    var r = this;
                    e.name == t && (i = e.values.map((function(e) {
                        return r.applyFilterString(e)
                    }
                    )))
                }
                .bind(this)),
                i
            },
            getVariantsOptionsWithAvailability: function(e, t) {
                var i = []
                  , r = this;
                return e.options.forEach(function(n) {
                    n.name == t && e.variants.forEach(function(e) {
                        var t = r.applyFilterString(e["option" + n.position]);
                        e.available && !i.includes(t) && i.push(t)
                    }
                    .bind(this))
                }
                .bind(this)),
                i
            },
            applyFilters: function() {
                var e = this
                  , t = Array.prototype.slice.call(document.querySelectorAll("#Collection li.grid__item"));
                t.forEach((function(e) {
                    e.classList.remove("hidden")
                }
                ));
                var i = [];
                if (t.forEach((function(e) {
                    i.push(parseInt(e.dataset.id))
                }
                )),
                this.filterActive) {
                    var r = i.filter((function(t) {
                        return !e.visibleProductsId.includes(t)
                    }
                    ));
                    r.forEach((function(e) {
                        document.querySelectorAll(".product-id-" + e).forEach(function(e) {
                            e.classList.add("hidden")
                        }
                        .bind(this))
                    }
                    )),
                    t.forEach(function(e) {
                        this.currentSelectedColor.length > 0 && -1 === this.currentSelectedColor.indexOf(e.dataset.color) && e.classList.add("hidden")
                    }
                    .bind(this))
                }
                this.hideSizesNotAvailable(),
                this.hideVendorsHiddenByFilter()
            },
            listenFilters: function() {
                Array.prototype.forEach.call(document.querySelectorAll(this.colorInput), function(e) {
                    this.hoverFiltersCheckbox(e),
                    e.addEventListener("change", function(e) {
                        e.target.checked ? -1 === this.currentSelectedColor.indexOf(e.target.value) && (this.currentSelectedColor.push(e.target.value),
                        this.createCancelFilterButton(e.target.value)) : -1 !== this.currentSelectedColor.indexOf(e.target.value) && (this.currentSelectedColor = this.currentSelectedColor.filter((function(t) {
                            return t !== e.target.value
                        }
                        )),
                        this.deleteCancelFilterButton(e.target.value),
                        e.target.parentElement.classList.remove("mouseover")),
                        this.run()
                    }
                    .bind(this))
                }
                .bind(this)),
                Array.prototype.forEach.call(document.querySelectorAll(this.sizeInput), function(e) {
                    this.hoverFiltersCheckbox(e),
                    e.addEventListener("change", function(e) {
                        e.target.checked ? -1 === this.currentSelectedSize.indexOf(e.target.value) && (this.currentSelectedSize.push(e.target.value),
                        this.createCancelFilterButton(e.target.value)) : -1 !== this.currentSelectedSize.indexOf(e.target.value) && (this.currentSelectedSize = this.currentSelectedSize.filter((function(t) {
                            return t !== e.target.value
                        }
                        )),
                        this.deleteCancelFilterButton(e.target.value),
                        e.target.parentElement.classList.remove("mouseover")),
                        this.run()
                    }
                    .bind(this))
                }
                .bind(this)),
                Array.prototype.forEach.call(document.querySelectorAll(this.typeInput), function(e) {
                    this.hoverFiltersCheckbox(e),
                    e.addEventListener("change", function(e) {
                        e.target.checked ? -1 === this.currentSelectedType.indexOf(e.target.value) && (this.currentSelectedType.push(e.target.value),
                        this.createCancelFilterButton(e.target.value)) : -1 !== this.currentSelectedType.indexOf(e.target.value) && (this.currentSelectedType = this.currentSelectedType.filter((function(t) {
                            return t !== e.target.value
                        }
                        )),
                        this.deleteCancelFilterButton(e.target.value),
                        e.target.parentElement.classList.remove("mouseover")),
                        this.run()
                    }
                    .bind(this))
                }
                .bind(this)),
                Array.prototype.forEach.call(document.querySelectorAll(this.materialInput), function(e) {
                    this.hoverFiltersCheckbox(e),
                    e.addEventListener("change", function(e) {
                        e.target.checked ? -1 === this.currentSelectedMaterial.indexOf(e.target.value) && (this.currentSelectedMaterial.push(e.target.value),
                        this.createCancelFilterButton(e.target.value)) : -1 !== this.currentSelectedMaterial.indexOf(e.target.value) && (this.currentSelectedMaterial = this.currentSelectedMaterial.filter((function(t) {
                            return t !== e.target.value
                        }
                        )),
                        this.deleteCancelFilterButton(e.target.value),
                        e.target.parentElement.classList.remove("mouseover")),
                        this.run()
                    }
                    .bind(this))
                }
                .bind(this)),
                Array.prototype.forEach.call(document.querySelectorAll(this.vendorInput), function(e) {
                    this.hoverFiltersCheckbox(e),
                    e.addEventListener("change", function(e) {
                        e.target.checked ? -1 === this.currentSelectedVendor.indexOf(e.target.value) && (this.currentSelectedVendor.push(e.target.value),
                        this.createCancelFilterButton(e.target.value)) : -1 !== this.currentSelectedVendor.indexOf(e.target.value) && (this.currentSelectedVendor = this.currentSelectedVendor.filter((function(t) {
                            return t !== e.target.value
                        }
                        )),
                        this.deleteCancelFilterButton(e.target.value),
                        e.target.parentElement.classList.remove("mouseover")),
                        this.run()
                    }
                    .bind(this))
                }
                .bind(this))
            },
            listenCancelButton: function(e) {
                e ? this.singleButtonListener(e) : Array.prototype.forEach.call(document.querySelectorAll(this.cancelInput), function(e) {
                    this.singleButtonListener(e)
                }
                .bind(this))
            },
            singleButtonListener: function(e) {
                e.addEventListener("click", function(t) {
                    for (var i, r = t.target; null == r.dataset.name; )
                        r = r.parentNode;
                    i = r.dataset.name,
                    this.currentSelectedColor = this.currentSelectedColor.filter((function(e) {
                        return e !== i
                    }
                    )),
                    this.currentSelectedSize = this.currentSelectedSize.filter((function(e) {
                        return e !== i
                    }
                    )),
                    this.currentSelectedType = this.currentSelectedType.filter((function(e) {
                        return e !== i
                    }
                    )),
                    this.currentSelectedVendor = this.currentSelectedVendor.filter((function(e) {
                        return e !== i
                    }
                    )),
                    this.currentSelectedMaterial = this.currentSelectedMaterial.filter((function(e) {
                        return e !== i
                    }
                    )),
                    document.querySelector(this.colorInput + ".color-" + i) && (document.querySelector(this.colorInput + ".color-" + i).checked = !1),
                    document.querySelector(this.sizeInput + ".size-" + i) && (document.querySelector(this.sizeInput + ".size-" + i).checked = !1),
                    document.querySelector(this.typeInput + ".type-" + i) && (document.querySelector(this.typeInput + ".type-" + i).checked = !1),
                    document.querySelector(this.materialInput + ".material-" + i) && (document.querySelector(this.materialInput + ".material-" + i).checked = !1),
                    document.querySelector(this.vendorInput + ".vendor-" + i) && (document.querySelector(this.vendorInput + ".vendor-" + i).checked = !1),
                    e.remove(),
                    this.run()
                }
                .bind(this))
            },
            hoverFiltersCheckbox: function(e) {
                e.parentElement.addEventListener("mouseover", function(e) {
                    e.target.classList.add("mouseover")
                }
                .bind(this)),
                e.parentElement.addEventListener("mouseout", function(e) {
                    e.target.classList.remove("mouseover")
                }
                .bind(this))
            },
            listenResetButton: function() {
                document.querySelector(".reset") && document.querySelectorAll(".reset").forEach(function(e) {
                    e.addEventListener("click", function(e) {
                        this.currentSelectedColor = [],
                        this.currentSelectedSize = [],
                        this.currentSelectedType = [],
                        this.currentSelectedVendor = [],
                        this.currentSelectedMaterial = [],
                        document.querySelectorAll(this.colorInput).forEach(function(e) {
                            e.checked = !1
                        }
                        .bind(this)),
                        document.querySelectorAll(this.sizeInput).forEach(function(e) {
                            e.checked = !1
                        }
                        .bind(this)),
                        document.querySelectorAll(this.typeInput).forEach(function(e) {
                            e.checked = !1
                        }
                        .bind(this)),
                        document.querySelectorAll(this.materialInput).forEach(function(e) {
                            e.checked = !1
                        }
                        .bind(this)),
                        document.querySelectorAll(this.vendorInput).forEach(function(e) {
                            e.checked = !1
                        }
                        .bind(this)),
                        document.querySelectorAll(this.cancelInput).forEach(function(e) {
                            e.classList.contains("hidden") || e.remove()
                        }
                        .bind(this)),
                        document.querySelector("#filter-btn").classList.remove("filters-active"),
                        document.querySelector("#Collection").classList.remove("filters-active"),
                        this.run()
                    }
                    .bind(this))
                }
                .bind(this))
            },
            updateUrl: function() {
                window.history.pushState(document.title, document.title, this.buildUrl())
            },
            buildUrl: function() {
                var e = location.pathname;
                return this.filterActive && (e += "?f=1",
                this.currentSelectedType.length > 0 && (e = e + "&type=" + encodeURIComponent(this.currentSelectedType.join(","))),
                this.currentSelectedColor.length > 0 && (e = e + "&color=" + encodeURIComponent(this.currentSelectedColor.join(","))),
                this.currentSelectedSize.length > 0 && (e = e + "&size=" + encodeURIComponent(this.currentSelectedSize.join(","))),
                this.currentSelectedMaterial.length > 0 && (e = e + "&material=" + encodeURIComponent(this.currentSelectedMaterial.join(","))),
                this.currentSelectedVendor.length > 0 && (e = e + "&vendor=" + encodeURIComponent(this.currentSelectedVendor.join(","))),
                this.currentSelectedSort.length > 0 && (e = e + "&" + this.sortParameter + "=" + encodeURIComponent(this.currentSelectedSort.join(",")))),
                e
            },
            selectFilterBoxes: function() {
                this.currentSelectedSize.forEach(function(e) {
                    document.querySelector(this.sizeInput + ".size-" + e).checked = !0,
                    this.createCancelFilterButton(e)
                }
                .bind(this)),
                this.currentSelectedColor.forEach(function(e) {
                    document.querySelector(this.colorInput + ".color-" + e).checked = !0,
                    this.createCancelFilterButton(e)
                }
                .bind(this)),
                this.currentSelectedType.forEach(function(e) {
                    document.querySelector(this.typeInput + ".type-" + e).checked = !0,
                    this.createCancelFilterButton(e)
                }
                .bind(this)),
                this.currentSelectedMaterial.forEach(function(e) {
                    document.querySelector(this.materialInput + ".material-" + e).checked = !0,
                    this.createCancelFilterButton(e)
                }
                .bind(this)),
                this.currentSelectedVendor.forEach(function(e) {
                    document.querySelector(this.vendorInput + ".vendor-" + e).checked = !0,
                    this.createCancelFilterButton(e)
                }
                .bind(this))
            },
            createCancelFilterButton: function(e) {
                if (document.querySelector("#filter-btn").classList.contains("filters-active") || document.querySelector("#filter-btn").classList.add("filters-active"),
                document.querySelector("#Collection").classList.contains("filters-active") || document.querySelector("#Collection").classList.add("filters-active"),
                !document.querySelector(this.cancelInput + "[data-name='" + e + "']")) {
                    var t = document.querySelector(this.cancelInput).cloneNode(!0);
                    t.classList.remove("hidden"),
                    t.dataset.name = e,
                    t.querySelector(".label-cancel-filter-button").innerHTML = this.revertFilterString(e),
                    document.querySelectorAll(this.activeFiltersToolbar).forEach(function(e) {
                        e.appendChild(t)
                    }
                    .bind(this)),
                    this.listenCancelButton(t)
                }
            },
            deleteCancelFilterButton: function(e) {
                document.querySelectorAll(this.cancelInput + "[data-name='" + e + "']").forEach(function(e) {
                    e.remove()
                }
                .bind(this))
            },
            updateFilterToolbar: function() {
                document.querySelector(this.activeFiltersToolbar) && (this.filterActive ? document.querySelectorAll(this.activeFiltersToolbar).forEach(function(e) {
                    e.parentNode.querySelector(".reset").classList.remove("hidden"),
                    e.parentNode.querySelector(".apply") && (e.parentNode.querySelector(".apply span[data-value='apply']").classList.remove("hidden"),
                    e.parentNode.querySelector(".apply span[data-value='close']").classList.add("hidden"))
                }
                .bind(this)) : document.querySelectorAll(this.activeFiltersToolbar).forEach(function(e) {
                    e.parentNode.querySelector(".reset").classList.add("hidden"),
                    e.parentNode.querySelector(".apply") && (e.parentNode.querySelector(".apply span[data-value='apply']").classList.add("hidden"),
                    e.parentNode.querySelector(".apply span[data-value='close']").classList.remove("hidden"))
                }
                .bind(this)))
            },
            toolbar: function() {
                document.querySelector("body").addEventListener("click", function(e) {
                    toolbarClicked = !1;
                    var t = [];
                    if (e.path)
                        t = e.path;
                    else
                        for (var i = e.target; i.parentNode; )
                            t.push(i),
                            i = i.parentNode;
                    t.forEach(function(e) {
                        e && e.classList && (e.classList.contains("filters-toolbar") || e.classList.contains(this.toolbarButton) && !document.getElementsByClassName(this.toolbarButton)[0].classList.contains("activeC")) && (toolbarClicked = !0)
                    }
                    .bind(this)),
                    !e.target.dataset.value || -1 == e.target.dataset.value.indexOf("close") && -1 == e.target.dataset.value.indexOf("apply") || (toolbarClicked = !1),
                    this.toggleFilterToolbar(toolbarClicked)
                }
                .bind(this))
            },
            toggleFilterToolbar: function(e) {
                var t = document.getElementsByClassName(this.toolbarButton)[0].parentNode.querySelector(".panel-filters");
                e ? (document.getElementsByClassName(this.toolbarButton)[0].classList.add("activeC"),
                t.classList.add("active-toolbar-filters")) : (document.getElementsByClassName(this.toolbarButton)[0].classList.remove("activeC"),
                t.classList.remove("active-toolbar-filters"))
            },
            changeGridImgColour: function() {
                Array.prototype.forEach.call(document.querySelectorAll(".product-info-wrapper .available-color li"), function(e) {
                    e.addEventListener("mouseover", function(t) {
                        this.listenerEventImgGridImg(t),
                        this.changeProductSizeAvailabilityInGrid(e)
                    }
                    .bind(this)),
                    e.addEventListener("mouseout", function(t) {
                        Array.prototype.forEach.call(document.querySelectorAll(".product-card__image-wrapper img.grid-color-image-hidden.grid-main-image"), (function(e) {
                            e.classList.remove("grid-color-image-hidden")
                        }
                        )),
                        Array.prototype.forEach.call(document.querySelectorAll(".product-card__image-wrapper img.grid-color-image:not(.grid-color-image-hidden)"), (function(e) {
                            e.classList.add("grid-color-image-hidden")
                        }
                        )),
                        this.changeProductSizeAvailabilityInGrid(e)
                    }
                    .bind(this))
                }
                .bind(this))
            },
            changeProductSizeAvailabilityInGrid: function(e) {
                if (window.Milanimal.Abstract.findAncestor(e, "grid__item")) {
                    var t = window.Milanimal.Abstract.findAncestor(e, "grid__item").dataset.id;
                    t && this.deactivateSizesProduct(t)
                }
            },
            listenerEventImgGridImg: function(e) {
                var t = e.target.dataset.value
                  , i = e.target.parentNode.parentNode.parentNode.parentNode.parentNode
                  , r = i.querySelectorAll(".product-card__image-wrapper img")
                  , n = i.querySelectorAll(".product-card__image-wrapper img[alt='" + t + "']");
                n.length > 0 && (Array.prototype.forEach.call(n, (function(e) {
                    e.classList.remove("grid-color-image-hidden")
                }
                )),
                Array.prototype.forEach.call(r, (function(e) {
                    e.getAttribute("alt") != t && e.classList.add("grid-color-image-hidden")
                }
                )))
            },
            deactivateAllUnavailableSizes: function() {
                for (var e in window.productsSizeAvailability)
                    this.deactivateSizesProduct(e, null)
            },
            deactivateSizesProduct: function(e, t) {
                var i = document.querySelectorAll("li.product-id-" + e);
                Array.prototype.forEach.call(i, function(i) {
                    var r = t || i.querySelectorAll("img")[0].getAttribute("alt");
                    r = this.applyFilterString(r);
                    var n = Array.prototype.slice.call(i.querySelectorAll(".available-sizes li"))
                      , a = 0;
                    n.forEach((function(t) {
                        console.log(e, ":", r),
                        window.productsSizeAvailability[e] && window.productsSizeAvailability[e][r] && !window.productsSizeAvailability[e][r][t.dataset.value] ? i.querySelector(".available-sizes [data-value='" + t.dataset.value + "']") && (i.querySelector(".available-sizes [data-value='" + t.dataset.value + "']").classList.add("option-not-available"),
                        a++) : (i.querySelector(".available-sizes [data-value='" + t.dataset.value + "']").classList.remove("option-not-available"),
                        a--)
                    }
                    )),
                    a == n.length ? i.querySelector("div.grid-view-item").classList.add("grid-view-item--sold-out") : i.querySelector("div.grid-view-item").classList.remove("grid-view-item--sold-out")
                }
                .bind(this))
            },
            applyFilterString: function(e) {
                return e.toUpperCase().replace(/ /g, "_").replace(/&/g, "AND").replace(/\//g, "_")
            },
            revertFilterString: function(e) {
                return e.replace(/_/g, " ").replace(/AND/g, "&")
            },
            hideSizesNotAvailable: function() {
                var e = [];
                for (var t in Array.prototype.forEach.call(document.querySelectorAll(this.sizeInput), function(t) {
                    e[t.value] = !1
                }
                .bind(this)),
                window.productsSizeAvailability)
                    for (var i in window.productsSizeAvailability[t])
                        if (document.querySelector("li.product-id-" + t) && !document.querySelector(".product-id-" + t).classList.contains("hidden"))
                            for (var r in window.productsSizeAvailability[t][i])
                                window.productsSizeAvailability[t][i][r] > 0 && (e[r] = !0);
                for (var n in e)
                    document.querySelector(this.sizeInput + ".size-" + n) && (e[n] ? document.querySelector(this.sizeInput + ".size-" + n).parentElement.classList.remove("hidden") : document.querySelector(this.sizeInput + ".size-" + n).parentElement.classList.add("hidden"))
            },
            hideVendorsHiddenByFilter: function() {
                if (0 !== this.visibleProducts.length) {
                    var e = [];
                    this.visibleProducts.forEach(function(t) {
                        e.includes(this.applyFilterString(t.vendor)) || e.push(this.applyFilterString(t.vendor))
                    }
                    .bind(this)),
                    console.log(e),
                    Array.prototype.forEach.call(document.querySelectorAll(this.vendorInput), function(t) {
                        e.includes(t.value) ? t.parentNode.classList.remove("hidden") : t.parentNode.classList.add("hidden")
                    }
                    .bind(this))
                } else
                    Array.prototype.forEach.call(document.querySelectorAll(this.vendorInput), function(e) {
                        e.parentNode.classList.remove("hidden")
                    }
                    .bind(this))
            }
        },
        Customer: {
            customerSidebar: null,
            mount: function() {
                document.getElementById("register-right") && document.getElementById("agree2").addEventListener("click", (function(e) {
                    e.target.checked ? document.querySelector(".register_tag_newsletter").value = "newsletter" : document.querySelector(".register_tag_newsletter").value = ""
                }
                )),
                this.sidebarActions()
            },
            sidebarActions: function() {
                this.customerSidebar = document.querySelector(".customer-sidebar");
                var e = document.querySelector(".site-header__account");
                e && !e.classList.contains("loggedin") && (e.addEventListener("click", function(e) {
                    this.customerSidebar.classList.contains("active") || (e.stopPropagation(),
                    e.preventDefault(),
                    this.openSidebarCustomer())
                }
                .bind(this)),
                jQuery(".site-close-handle, header, .page-container, .closebtn").on("click", function() {
                    this.customerSidebar.classList.contains("active") && this.closeSidebarCustomer()
                }
                .bind(this)))
            },
            openSidebarCustomer: function() {
                this.customerSidebar.classList.add("active")
            },
            closeSidebarCustomer: function() {
                this.customerSidebar.classList.remove("active")
            }
        },
        Membership: {
            corso: "adults",
            durata: "opzione-12-months",
            selected: !1,
            membershipManaged: !1,
            rules: {},
            pagesEnabled: ["/pages/membership"],
            init: function() {
                this.pagesEnabled.includes(location.pathname) && (this.rules = window.MembershipRules,
                this.mainBlocks(),
                this.triggerBoxes())
            },
            updateReview: function() {
                var e = this.rules[this.corso][this.durata]
                  , t = document.getElementById("breadcrumbs");
                t.querySelector(".categoria").innerText = this.corso;
                var i = t.querySelector(".categoria").classList[1];
                "categoria" == i && (i = t.querySelector(".categoria").classList[0]),
                t.querySelector(".categoria").classList.replace(i, this.corso),
                t.querySelector(".frequenza-selezione").innerText = e.name;
                var r = document.getElementById("payment-selectors")
                  , n = 0
                  , a = 0
                  , o = 0
                  , c = 0
                  , l = 0
                  , s = ""
                  , d = "";
                1 == e.options.length ? (r.querySelector(".payment-monthly").classList.add("hidden"),
                r.querySelector(".payment-prepaid").querySelector(".best-price") && (r.querySelector(".payment-prepaid").querySelector(".best-price").classList.add("normal-price"),
                r.querySelector(".payment-prepaid").querySelector(".best-price").classList.remove("best-price")),
                n = e.options[0].price,
                l = e.options[0].contract_id,
                d = e.options[0].text_payment) : (r.querySelector(".payment-monthly").classList.remove("hidden"),
                r.querySelector(".payment-prepaid").querySelector(".normal-price") && (r.querySelector(".payment-prepaid").querySelector(".normal-price").classList.add("best-price"),
                r.querySelector(".payment-prepaid").querySelector(".normal-price").classList.remove("normal-price")),
                e.options.forEach((function(e) {
                    parseInt(e.installments) > 0 ? (a = e.price,
                    o = e.installments,
                    c = e.contract_id,
                    s = e.text_payment) : (n = e.price,
                    l = e.contract_id,
                    d = e.text_payment)
                }
                ))),
                jQuery("#testo").html(jQuery("#testo").html(e.description).text()),
                r.querySelector(".payment-monthly").querySelector("span.pricetag").innerText = a,
                r.querySelector(".payment-monthly").querySelector("span.text_membership_payment").innerText = s,
                r.querySelector(".payment-monthly").querySelector("input").dataset.contract = c,
                r.querySelector(".payment-prepaid").querySelector("span.pricetag").innerText = n,
                r.querySelector(".payment-prepaid").querySelector("span.text_membership_payment").innerText = d,
                r.querySelector(".payment-prepaid").querySelector("input").dataset.contract = l,
                r.querySelector(".payment-prepaid").querySelector("span.discount-prepaid").innerText = Math.ceil(100 * (1 - parseInt(n) / (parseInt(a) * parseInt(o))));
                var u = document.querySelector("#total-price .pricetag")
                  , h = parseInt(n);
                u.innerText = "option-1-entrance" !== this.durata ? Math.ceil(h + 10) : h,
                this.updateProceedButton(l, "add_service");
                var m = document.querySelector(".welcome-text")
                  , p = document.querySelector(".membership-review");
                p.classList.contains("hidden") && (p.classList.remove("hidden"),
                m.classList.add("hidden"))
            },
            selectBoxes: function() {
                document.querySelectorAll(".enabled").forEach((function(e) {
                    e.classList.remove("enabled")
                }
                ));
                var e = document.getElementById(this.corso).querySelector(".row-memb")
                  , t = document.getElementById(this.durata);
                e.classList.add("enabled"),
                t.classList.add("enabled")
            },
            triggerBoxes: function() {
                document.querySelectorAll(".option").forEach(function(e) {
                    e.addEventListener("click", function(e) {
                        var t = e.target;
                        "SPAN" == t.nodeName && (t = window.Milanimal.Abstract.findAncestor(t, "option")),
                        this.durata = t.getAttribute("id");
                        var i = window.Milanimal.Abstract.findAncestor(t, "wrapper-corso");
                        this.corso = i.getAttribute("id"),
                        this.updateReview(),
                        this.selectBoxes(),
                        this.manageMembershipFee()
                    }
                    .bind(this), !0)
                }
                .bind(this))
            },
            manageMembershipFee: function() {
                var e = document.querySelector(".subscription");
                if (e && ("option-1-entrance" === this.durata ? e.classList.add("hidden") : e.classList.remove("hidden")),
                !this.membershipManaged) {
                    var t = document.querySelector(".registration-button");
                    document.querySelector(".membership-fee-add") && t && (this.membershipManaged = !0)
                }
            },
            updateTotal: function(e) {
                var t = parseInt(e.parentElement.querySelector(".pricetag").innerText);
                document.querySelector("#total-price .pricetag").innerText = "option-1-entrance" !== this.durata ? Math.ceil(t + 10) : t,
                "payone" == e.value ? this.updateProceedButton(e.dataset.contract, "add_service") : this.updateProceedButton(e.dataset.contract, "add_contract")
            },
            updateProceedButton: function(e, t) {
                var i = "https://cart.mindbodyonline.com/";
                i += "sites/" + document.querySelector("healcode-widget").dataset.siteId,
                i += "/cart/" + t + "?mbo_item_id=" + e,
                this.manageMembershipFee();
                var r = document.querySelector(".registration-button");
                r && (r.dataset.url = i)
            },
            mainBlocks: function() {
                document.querySelectorAll(".row-memb").forEach(function(e) {
                    e.addEventListener("click", function(e) {
                        var t = e.target.parentElement;
                        t.classList.contains("active") || (document.querySelector(".wrapper-corso.active") && document.querySelector(".wrapper-corso.active").classList.remove("active"),
                        t.classList.add("active"))
                    }
                    .bind(this), !0)
                }
                .bind(this))
            }
        }
    },
    window.Milanimal.Cart.mount(),
    window.Milanimal.Product.mount(),
    window.Milanimal.CollectionAjax.mount(),
    window.Milanimal.Customer.mount(),
    window.Milanimal.Membership.init();
    var r, n = location.href.match(/([^\/]*)\/*$/)[1], a = document.querySelectorAll(".collection-link");
    for (r = 0; r < a.length; ++r)
        a[r].id == n && a[r].classList.add("active");
    var o = document.getElementById("video")
      , c = document.querySelector(".main-content");
    null != o && c.classList.add("video-main-content");
    var l, s = document.getElementsByClassName("accordion");
    for (l = 0; l < s.length; l++)
        s[l].addEventListener("click", (function(e) {
            var t = this.nextElementSibling;
            for (jj = 0; jj < s.length; jj++)
                jj !== l && (s[jj].nextElementSibling.style.maxHeight = null,
                s[jj].classList.remove("activeA"));
            t.classList.contains("active") ? (t.style.maxHeight = null,
            t.classList.remove("active"),
            e.target.classList.remove("activeA")) : (t.style.maxHeight = t.scrollHeight + "px",
            t.classList.add("active"),
            e.target.classList.add("activeA"))
        }
        ));
    var d, u, h, m, p, f, v, y, g, b = document.getElementsByClassName("accordion-footer");
    for (u = 0; u < b.length; u++)
        b[u].addEventListener("click", (function() {
            this.classList.toggle("activeB");
            var e = this.nextElementSibling;
            e.style.maxHeight ? e.style.maxHeight = null : e.style.maxHeight = e.scrollHeight + "px"
        }
        ));
    $("#collection1").mousedown((function(e) {
        e.preventDefault(),
        p = !0,
        d = e.pageX,
        u = e.pageY,
        h = $(this).scrollTop(),
        m = $(this).scrollLeft()
    }
    )),
    $("#collection2").mousedown((function(e) {
        e.preventDefault(),
        f = !0,
        d = e.pageX,
        u = e.pageY,
        h = $(this).scrollTop(),
        m = $(this).scrollLeft()
    }
    )),
    $("#collection3").mousedown((function(e) {
        e.preventDefault(),
        v = !0,
        d = e.pageX,
        u = e.pageY,
        h = $(this).scrollTop(),
        m = $(this).scrollLeft()
    }
    )),
    $("#collection4").mousedown((function(e) {
        e.preventDefault(),
        y = !0,
        d = e.pageX,
        u = e.pageY,
        h = $(this).scrollTop(),
        m = $(this).scrollLeft()
    }
    )),
    $("#insta-feed").mousedown((function(e) {
        e.preventDefault(),
        g = !0,
        d = e.pageX,
        u = e.pageY,
        h = $(this).scrollTop(),
        m = $(this).scrollLeft()
    }
    )),
    $("body").mousemove((function(e) {
        if (p) {
            var t = e.pageX
              , i = e.pageY;
            $("#collection1").scrollTop(h - i + u),
            $("#collection1").scrollLeft(m - t + d)
        }
        if (f) {
            t = e.pageX,
            i = e.pageY;
            $("#collection2").scrollTop(h - i + u),
            $("#collection2").scrollLeft(m - t + d)
        }
        if (v) {
            t = e.pageX,
            i = e.pageY;
            $("#collection3").scrollTop(h - i + u),
            $("#collection3").scrollLeft(m - t + d)
        }
        if (y) {
            t = e.pageX,
            i = e.pageY;
            $("#collection4").scrollTop(h - i + u),
            $("#collection4").scrollLeft(m - t + d)
        }
        if (g) {
            t = e.pageX,
            i = e.pageY;
            $("#insta-feed").scrollTop(h - i + u),
            $("#insta-feed").scrollLeft(m - t + d),
            $("#insta-feed").addClass("noClick")
        } else
            $("#insta-feed").removeClass("noClick")
    }
    )),
    $("body").mouseup((function(e) {
        p = !1,
        f = !1,
        v = !1,
        y = !1,
        g = !1
    }
    ));
    var S, w = document.querySelectorAll(".feature-row__image")[1], q = document.getElementById("col-thumb");
    function L() {
        if (w && q) {
            var e = w.height;
            q.style.maxHeight = "".concat(e, "px");
            var t = document.querySelectorAll(".product-single__thumbnail-image");
            if (t)
                for (u = 0; u < t.length; ++u)
                    t[u].style.height = "".concat(e / 2, "px")
        }
    }
    function C(e) {
        Array.prototype.forEach.call(document.querySelectorAll(e), (function(e) {
            e.addEventListener("click", (function(e) {
                if ("IMG" == e.target.nodeName) {
                    var t = document.querySelector(".modal-class:not(.hidden)");
                    if (t)
                        t.classList.add("hidden");
                    else {
                        var i = e.target.parentNode.querySelector(".modal-class");
                        i || (i = e.target.parentNode.parentNode.querySelector(".modal-class")),
                        i.classList.contains("hidden") ? i.classList.remove("hidden") : i.classList.add("hidden")
                    }
                }
            }
            ))
        }
        ))
    }
    jQuery(document).ready((function() {
        if (w && q) {
            var e = w.height;
            q.style.maxHeight = "".concat(e, "px");
            var t = document.querySelectorAll(".product-single__thumbnail-image");
            for (k = 0; k < t.length; ++k)
                t[k].style.height = "".concat(e / 2, "px")
        }
    }
    )),
    window.addEventListener("resize", L),
    L(),
    window.Milanimal.Abstract.mobileCheck() || C(".colonna-collection"),
    C(".colonna-campaigns"),
    window.Milanimal.Abstract.mobileCheck() && C(".article-image .image"),
    window.Milanimal.Abstract.mobileCheck() || (S = ".product-single__photo > img",
    Array.prototype.forEach.call(document.querySelectorAll(S), (function(e) {
        e.addEventListener("click", (function(e) {
            var t = document.querySelector(".modal-class:not(.hidden)");
            if (t)
                t.classList.add("hidden");
            else {
                var i = e.target.nextElementSibling;
                i && (i.classList.remove("hidden"),
                i.addEventListener("click", (function(e) {
                    var t = e.target;
                    t.classList.contains("modal-class") || (t = t.parentNode),
                    t.classList.add("hidden"),
                    t.removeEventListener("click", (function() {}
                    ))
                }
                )))
            }
        }
        ))
    }
    ))),
    $((function() {
        function e(e, t) {
            var i = $(e)
              , r = $(t)
              , n = i.outerWidth()
              , a = i[0].scrollWidth / n - 1
              , o = 20
              , c = 0
              , l = 0
              , s = n - 40
              , d = n / s;
            i.mousemove((function(e) {
                o = e.pageX - this.offsetLeft,
                c = Math.min(Math.max(0, o - 20), s) * d
            }
            )),
            setInterval((function() {
                l += (c - l) / 20,
                r.css({
                    marginLeft: -l * a
                })
            }
            ), 10)
        }
        if (window.slideCampaigns = e,
        window.Milanimal.Abstract.mobileCheck())
            for (var t = 1; t <= document.querySelectorAll(".section-campaign-wrapper").length; t++)
                document.querySelector(".campaign-section.campaign-section-" + t).style.position = "relative";
        else
            var i = setInterval((function() {
                if (document.querySelectorAll(".lazyloaded").length > 20) {
                    clearInterval(i);
                    for (var t = 2; t <= document.querySelectorAll(".section-campaign-wrapper").length; t++)
                        e(".section-campaign-wrapper.campaign-wrapper-section-" + t, ".campaign-section.campaign-section-" + t)
                }
                1 == window.Milanimal.Abstract.getQueryVariable("campaign") && (clearInterval(i),
                e(".section-campaign-wrapper.campaign-wrapper-section-1", ".campaign-section.campaign-section-1"))
            }
            ), 100)
    }
    )),
    window.Milanimal.Abstract.mobileCheck() ? $("#myHeader").addClass("blackBg") : $(window).scroll((function() {
        $(window).scrollTop() >= 50 ? $("#myHeader").addClass("blackBg") : $("#myHeader").removeClass("blackBg")
    }
    )),
    $(".required:checked").length,
    $(".required").length,
    $(document).ready((function() {
        $("body").on("click", "#RegisterForm .btn", (function() {
            if ($(".required:checked").length != $(".required").length)
                return alert("You must agree with the terms and conditions."),
                !1;
            $(this).submit()
        }
        ))
    }
    )),
    document.querySelectorAll("#MobileNav span").forEach((function(e) {
        e.addEventListener("click", (function(e) {
            document.querySelectorAll(".mega-menu-container:not(.hidden)").forEach((function(e) {
                e.classList.add("hidden")
            }
            )),
            document.querySelectorAll("#MobileNav span.menu-link-selected").forEach((function(e) {
                e.classList.remove("menu-link-selected")
            }
            )),
            e.target.classList.add("menu-link-selected"),
            document.querySelector(".mega-menu-container." + e.target.dataset.desc).classList.remove("hidden")
        }
        ))
    }
    )),
    document.querySelectorAll(".mega-menu-title li").forEach((function(e) {
        e.addEventListener("click", (function(e) {
            document.querySelectorAll(".mega-menu-description div:not(.hidden)").forEach((function(e) {
                e.classList.add("hidden")
            }
            )),
            document.querySelectorAll(".mega-menu-title li.menu-link-selected").forEach((function(e) {
                e.classList.remove("menu-link-selected")
            }
            )),
            e.target.classList.add("menu-link-selected"),
            document.querySelector(".mega-menu-description div." + e.target.dataset.desc).classList.remove("hidden")
        }
        ))
    }
    )),
    document.querySelectorAll(".mega-container li a").forEach((function(e) {
        var t = "menu-link-selected";
        if (-1 != document.location.href.indexOf(e.getAttribute("href"))) {
            e.parentElement.classList.add(t);
            var i = window.Milanimal.Abstract.findAncestor(e, "mega-container");
            document.querySelector("span[data-menu='" + i.classList[1].split("-")[1] + "']") && document.querySelector("span[data-menu='" + i.classList[1].split("-")[1] + "']").classList.add(t)
        }
    }
    ));
    var A = !1;
    document.querySelectorAll(".mega-menu-only-description li a, .mega-menu-description li a").forEach((function(e) {
        var t = "menu-link-selected";
        if (-1 != document.location.href.indexOf(e.getAttribute("href"))) {
            e.parentElement.classList.add(t),
            document.querySelector("li[data-desc='" + e.parentElement.parentElement.parentElement.classList[0] + "']") && (e.parentElement.parentElement.parentElement.classList.remove("hidden"),
            document.querySelector("li[data-desc='" + e.parentElement.parentElement.parentElement.classList[0] + "']").classList.add(t));
            var i = window.Milanimal.Abstract.findAncestor(e, "mega-menu-container");
            i.classList.remove("hidden"),
            document.querySelector("span[data-desc='" + i.classList[0] + "']") && document.querySelector("span[data-desc='" + i.classList[0] + "']").classList.add(t),
            A = !0
        }
    }
    )),
    A || (document.querySelector(".mega-shop-1") && document.querySelector(".mega-shop-1").classList.remove("hidden"),
    document.querySelector("li[data-desc='mega-shop-1']") && document.querySelector("li[data-desc='mega-shop-1']").classList.remove("hidden"),
    document.querySelector(".mega-menu-shop.mega-menu-container") && document.querySelector(".mega-menu-shop.mega-menu-container").classList.remove("hidden")),
    document.querySelector(".hamburger button").addEventListener("click", (function(e) {
        var t = e.target;
        "BUTTON" != t.nodeName && (t = window.Milanimal.Abstract.findAncestor(e.target, "btn--link")),
        t.classList.contains("mobile-nav--open") ? document.querySelector("#myHeader").classList.add("megamenu-open") : document.querySelector("#myHeader").classList.remove("megamenu-open")
    }
    )),
    document.querySelector(".close-search") && document.querySelector(".close-search").addEventListener("click", (function(e) {
        document.querySelector("body").classlist.remove("js-drawer-open").remove("js-drawer-open-top")
    }
    )),
    document.querySelectorAll(".open-shop-the-look").forEach((function(e) {
        e.addEventListener("click", (function(e) {
            var t = e.target.nextElementSibling;
            t.classList.contains("hidden") ? t.classList.remove("hidden") : t.classList.add("hidden")
        }
        ))
    }
    )),
    document.querySelectorAll(".close-shop-the-look").forEach((function(e) {
        e.addEventListener("click", (function(e) {
            e.target.parentNode.classList.add("hidden")
        }
        ))
    }
    )),
    jQuery(".lines-images-mobile") && (jQuery(".lines-images-mobile span").first().addClass("active"),
    jQuery(".product-single__photo-wrapper div").first().scroll((function() {
        var e = jQuery(".product-single__photo-wrapper div").first().scrollLeft() / jQuery(window).width();
        jQuery(".lines-images-mobile span")[Math.ceil(e)] && (jQuery(".lines-images-mobile span.active").removeClass("active"),
        jQuery(".lines-images-mobile span")[Math.ceil(e)].classList.add("active"))
    }
    ))),
    jQuery((function(e) {
        e(".js-accordion-title").on("click", (function() {
            e(this).next().slideToggle(100),
            e(this).toggleClass("open", 100)
        }
        ))
    }
    ))
}
)();
